import { defineComponent as t, openBlock as n, createBlock as l, unref as p, mergeProps as s, withCtx as i, createElementVNode as a } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const f = /* @__PURE__ */ t({
  name: "IconCrosshair",
  __name: "IconCrosshair",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const r = o;
    return (c, e) => (n(), l(p(m), s(r, { "view-box": "0 0 24 24" }), {
      default: i(() => [...e[0] || (e[0] = [
        a("path", { d: "M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4" }, null, -1),
        a("path", {
          "fill-rule": "evenodd",
          d: "M12 2.25A.75.75 0 0 1 12.75 3v1.286a7.75 7.75 0 0 1 6.964 6.964H21a.75.75 0 0 1 0 1.5h-1.286a7.75 7.75 0 0 1-6.964 6.964V21a.75.75 0 0 1-1.5 0v-1.286a7.75 7.75 0 0 1-6.964-6.964H3a.75.75 0 0 1 0-1.5h1.286a7.75 7.75 0 0 1 6.964-6.964V3A.75.75 0 0 1 12 2.25m-6.205 10.5H7a.75.75 0 0 0 0-1.5H5.795a6.25 6.25 0 0 1 5.455-5.455V7a.75.75 0 0 0 1.5 0V5.795a6.25 6.25 0 0 1 5.456 5.455H17a.75.75 0 0 0 0 1.5h1.206a6.25 6.25 0 0 1-5.456 5.456V17a.75.75 0 0 0-1.5 0v1.206a6.25 6.25 0 0 1-5.455-5.456",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
